import { getReservationEmailPending, getReservationEmailSuccess, getReservationEmailFail, 
    deleteReservationEmailPending, deleteReservationEmailSuccess, deleteReservationEmailFail,
    getSReservationEmailPending, getSReservationEmailSuccess, getSReservationEmailFail, 
    createReservationEmailPending, createReservationEmailSuccess, createReservationEmailFail, 
    modifyReservationEmailPending, modifyReservationEmailSuccess, modifyReservationEmailFail } from "./ReservationEmailSlice";
import { fetchAllReservationEmail, reservationEmailDelete, reservationEmailCreation, reservationEmailModify, fetchSingleReservationEmail } from "../../../api/userApi";
import Swal from "sweetalert2";

export const getAllReservationEmail = () => async (dispatch) => {
    try {
      
        dispatch(getReservationEmailPending());
        const result = await fetchAllReservationEmail();
       
        const myJSON = JSON.stringify(result);

        
        const myObj = JSON.parse(myJSON);
        const reservationEmaildetails = JSON.parse(JSON.stringify(myObj.reservationemails));
        const reservationEmaildetails1 = JSON.parse(JSON.stringify(reservationEmaildetails));
        
        if (reservationEmaildetails) {
        
            return dispatch(getReservationEmailSuccess(reservationEmaildetails));
        }
        dispatch(getReservationEmailFail("Reservation Email is not found"));


    } catch (error) {
       //console.log(error.msg);
        const err = JSON.parse(JSON.stringify(error));
        // console.log(err.message);
         //console.log(JSON.parse(JSON.stringify(error)));
         dispatch(getReservationEmailFail(err.msg));

    }
}

export const reservationEmailDeletion = (frmDt) => async(dispatch) => {

    try {
        dispatch(deleteReservationEmailPending());
        const result = await reservationEmailDelete(frmDt);
       // console.log("userCreation "+result);
      // console.log("try block");
       //console.log(result.status);
        result.status ==="success" 
        ? dispatch(deleteReservationEmailSuccess("Reservation Email deleted"))
        : dispatch(deleteReservationEmailFail(result.message));
        
    } catch (error) {
       // console.log("catch block");
       const err = JSON.parse(JSON.stringify(error.response.data.error));
       // console.log(err.message);
        //console.log(JSON.parse(JSON.stringify(error)));
        dispatch(deleteReservationEmailFail(err.msg));
    }
    
}

export const newReservationEmailCreation = (frmDt) => async (dispatch) => {
   
    try {
        dispatch(createReservationEmailPending());
        const result = await reservationEmailCreation(frmDt);
        //console.log(result.status==="fail");
        result.status === "success"
            ? dispatch(createReservationEmailSuccess(result.message))
            : dispatch(createReservationEmailFail(result.message));

        

    } catch (error) {
        console.log(error);
        
         if(error.response.status===401){}
        const err = JSON.parse(JSON.stringify(error.response.data.error));
         
         Swal.fire(err.msg, '', 'error');
          dispatch(createReservationEmailFail(err.msg));
       
       
       
    }

}

export const getSingleReservationEmail = (id) => async (dispatch) => {
    
 
 
    try {
     //call the api
    dispatch(getSReservationEmailPending());
    const result = await fetchSingleReservationEmail(id);
   // const userData=JSON.parse(result.user);
 console.log('ReservationEmailData ');
 //console.log(result);
 console.log(result.reservationemails);
 
 //console.log('check user profile out if');
    if(result.reservationemails[0] && result.reservationemails[0].id){
    //console.log('check user profile');
        return dispatch(getSReservationEmailSuccess(result.reservationemails[0]));
    }
    dispatch(getSReservationEmailFail("Reservation Email is not found"));
 
   
 } catch (error) {
    // console.log("catch block");
    const err = JSON.parse(JSON.stringify(error.response.data.error));
    //console.log(error);
    console.log(err.msg);
    dispatch(getSReservationEmailFail(err.msg));
 
 }
    
 
 }




export const reservationEmailModification = (frmDt) => async (dispatch) => {
   
    try {
        dispatch(modifyReservationEmailPending());
        const result = await reservationEmailModify(frmDt);
        result.status === "success"
            ? dispatch(modifyReservationEmailSuccess(result.message))
            : dispatch(modifyReservationEmailFail(result.message));

    

    } catch (error) {
        
        const err = JSON.parse(JSON.stringify(error.response.data.error));
        Swal.fire(err.msg, '', 'error');
        dispatch(modifyReservationEmailFail(err.msg));
    }

}
